"use client"

import React, { useEffect } from "react"
import { format } from "date-fns"
import { CalendarIcon } from "lucide-react"
import { DateRange } from "react-day-picker"
import { Table } from "@tanstack/react-table"

import { cn } from "@/lib/utils"
import { Button } from "../components/ui/button"
import { Calendar } from "@/app/components/ui/calendar"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/app/components/ui/popover"
import { useSearchParams } from "next/navigation"

export default function DateFilterButton({ table }: { table: Table<any> }) {
    const [date, setDate] = React.useState<DateRange | undefined>(undefined)
    // const searchParams = useSearchParams();

    // useEffect(() => {
    //     const startDate = searchParams.get('startDate');
    //     const endDate = searchParams.get('endDate');
    //     if (startDate && endDate) {
    //         setDate({ from: new Date(startDate), to: new Date(endDate) });
    //     }
    // }, [searchParams]);

    // Apply the filter whenever date changes
    useEffect(() => {
        if (date?.from) {
            table.setColumnFilters([{
                id: "createdAt",
                value: [date.from, date.to || new Date()]
            }]);
        } else {
            // Clear the filter if no date is selected
            table.setColumnFilters(table.getState().columnFilters.filter(
                filter => filter.id !== "createdAt"
            ));
        }
    }, [date, table]);

    // Move to first page on filter
    const handleDateChange = (date: DateRange | undefined) => {
        table.setPageIndex(1);

        const params = new URLSearchParams(window.location.search);
        params.set('page', '1');
        // params.set('startDate', date?.from?.toISOString() ?? '');
        // params.set('endDate', date?.to?.toISOString() ?? '');
        window.history.replaceState(null, '', `?${params.toString()}`);

        setDate(date);
    }

    return (
        <div className="grid gap-2">
            <Popover>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        className={cn(
                            "w-[240px] justify-start text-left font-normal",
                            !date && "text-muted-foreground"
                        )}
                    >
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {date?.from ? (
                            date.to ? (
                                <>
                                    {format(date.from, "MMM dd, yyyy")} -{" "}
                                    {format(date.to, "MMM dd, yyyy")}
                                </>
                            ) : (
                                format(date.from, "MMM dd, yyyy")
                            )
                        ) : (
                            <span>Filter by Date</span>
                        )}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                        initialFocus
                        mode="range"
                        defaultMonth={date?.from}
                        selected={date}
                        onSelect={handleDateChange}
                        numberOfMonths={2}
                    />
                </PopoverContent>
            </Popover>
        </div>
    )
}
